<template>
  <div></div>
</template>
<script>

import {setToken} from "@/utils/auth";
import store from "@/store";

export default {
  name: "loginToUser",
  computed: {},
  data() {
    return {};
  },
  async created() {
    let isAdmin = this.$route.query.isAdmin;
    let isShopUser = this.$route.query.isShopUser;

    let token = this.$route.query.token;
    let url = this.$route.query.url;

    token && setToken(token)

    if (isShopUser === 'true') {
      window.location.href = `${this.sellerSiteAddress}?${isAdmin ? ('isAdmin=' + isAdmin) : ''}`
    } else {
      await store.dispatch("user/getUserInfo")
      await store.dispatch("user/getUserMoney");
      await store.dispatch("user/getUserLevel");
      await store.dispatch("user/getUserCart");
      await store.dispatch("user/getWishList");
      await store.dispatch("user/getCompareList");
      await store.dispatch("user/initSocket");
      // debugger
      this.jump(url || '/home')
      // window.location.reload()
    }
  },
  methods: {
    getRootDomain(url) {
      const urlObject = new URL(url);
      const parts = urlObject.hostname.split('.');
      const rootDomainParts = parts.slice(-2);
      return rootDomainParts.join('.');
    }
  }
};
</script>
